module.exports = __webpack_public_path__ + "static/media/seadoo_logo.9a7e5a13.png";